
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/search",
      function () {
        return require("private-next-pages/catalog/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/search"])
      });
    }
  